import BaseApi from '~/api/base';
class Projects extends BaseApi {
    constructor() {
        super('/projects');
    }
}
const ProjectsApi = new Projects();
export default ProjectsApi;
